import { useMutation, useQueryClient } from '@tanstack/react-query'
import { markAsReadAllNoticeApi } from '@/api/noticeApi'

export const useMarkAsReadNotice = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => markAsReadAllNoticeApi(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['noticeList'] })
    }
  })
}
